define.alias("ember-math-helpers/helpers/log1p", "media/helpers/log1p");